export const hexToRgb = (hex: string): [number, number, number] => {
  const [match, hexR, hexG, hexB] = hex.match(/^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i) || [];

  if (!match) {
    return [0, 0, 0];
  }

  return [parseInt(hexR, 16), parseInt(hexG, 16), parseInt(hexB, 16)];
};
